var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef } from 'react';
import { Button } from '../../UI/Button';
import { Progress } from '../../UI/Progress';
import { Upload, FileText, Image, Music, Video, File, X, Check, AlertCircle, CloudUpload } from 'lucide-react';
import { cn } from '../../../lib/utils';
var getFileIcon = function (type) {
    if (type.startsWith('image/'))
        return Image;
    if (type.startsWith('audio/'))
        return Music;
    if (type.startsWith('video/'))
        return Video;
    if (type.includes('pdf') || type.includes('document') || type.includes('text'))
        return FileText;
    return File;
};
var formatFileSize = function (bytes) {
    if (bytes === 0)
        return '0 Bytes';
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
export var DragDropUpload = function (_a) {
    var onFilesUpload = _a.onFilesUpload, _b = _a.acceptedTypes, acceptedTypes = _b === void 0 ? ['.pdf', '.doc', '.docx', '.txt', 'image/*', 'audio/*', 'video/*'] : _b, _c = _a.maxFileSize, maxFileSize = _c === void 0 ? 50 : _c, // 50MB default
    _d = _a.maxFiles, // 50MB default
    maxFiles = _d === void 0 ? 10 : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, className = _a.className, _f = _a.showPreview, showPreview = _f === void 0 ? true : _f;
    var _g = useState(false), isDragOver = _g[0], setIsDragOver = _g[1];
    var _h = useState([]), uploadQueue = _h[0], setUploadQueue = _h[1];
    var _j = useState(false), isUploading = _j[0], setIsUploading = _j[1];
    var fileInputRef = useRef(null);
    var dragCounterRef = useRef(0);
    var validateFile = useCallback(function (file) {
        var _a;
        // Check file size
        if (file.size > maxFileSize * 1024 * 1024) {
            return "File size exceeds ".concat(maxFileSize, "MB limit");
        }
        // Check file type
        var fileExtension = '.' + ((_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        var isAccepted = acceptedTypes.some(function (type) {
            if (type.includes('*')) {
                return file.type.startsWith(type.replace('*', ''));
            }
            return type === fileExtension || type === file.type;
        });
        if (!isAccepted) {
            return 'File type not supported';
        }
        return null;
    }, [acceptedTypes, maxFileSize]);
    var handleFiles = useCallback(function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var fileArray, validFiles, newUploadQueue, _i, fileArray_1, file, error, uploadFile, _loop_1, _a, _b, uploadFile, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (disabled || isUploading)
                        return [2 /*return*/];
                    fileArray = Array.from(files);
                    // Check max files limit
                    if (fileArray.length > maxFiles) {
                        alert("You can only upload up to ".concat(maxFiles, " files at once"));
                        return [2 /*return*/];
                    }
                    validFiles = [];
                    newUploadQueue = [];
                    for (_i = 0, fileArray_1 = fileArray; _i < fileArray_1.length; _i++) {
                        file = fileArray_1[_i];
                        error = validateFile(file);
                        uploadFile = {
                            id: "".concat(file.name, "-").concat(Date.now(), "-").concat(Math.random()),
                            file: file,
                            progress: 0,
                            status: error ? 'error' : 'pending',
                            error: error || undefined
                        };
                        newUploadQueue.push(uploadFile);
                        if (!error) {
                            validFiles.push(file);
                        }
                    }
                    setUploadQueue(function (prev) { return __spreadArray(__spreadArray([], prev, true), newUploadQueue, true); });
                    if (!(validFiles.length > 0)) return [3 /*break*/, 9];
                    setIsUploading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    _loop_1 = function (uploadFile) {
                        var _loop_2, progress;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    setUploadQueue(function (prev) { return prev.map(function (f) {
                                        return f.id === uploadFile.id ? __assign(__assign({}, f), { status: 'uploading' }) : f;
                                    }); });
                                    _loop_2 = function (progress) {
                                        return __generator(this, function (_e) {
                                            switch (_e.label) {
                                                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                                                case 1:
                                                    _e.sent();
                                                    setUploadQueue(function (prev) { return prev.map(function (f) {
                                                        return f.id === uploadFile.id ? __assign(__assign({}, f), { progress: progress }) : f;
                                                    }); });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    };
                                    progress = 0;
                                    _d.label = 1;
                                case 1:
                                    if (!(progress <= 100)) return [3 /*break*/, 4];
                                    return [5 /*yield**/, _loop_2(progress)];
                                case 2:
                                    _d.sent();
                                    _d.label = 3;
                                case 3:
                                    progress += 10;
                                    return [3 /*break*/, 1];
                                case 4:
                                    setUploadQueue(function (prev) { return prev.map(function (f) {
                                        return f.id === uploadFile.id ? __assign(__assign({}, f), { status: 'success', progress: 100 }) : f;
                                    }); });
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _a = 0, _b = newUploadQueue.filter(function (f) { return f.status === 'pending'; });
                    _c.label = 2;
                case 2:
                    if (!(_a < _b.length)) return [3 /*break*/, 5];
                    uploadFile = _b[_a];
                    return [5 /*yield**/, _loop_1(uploadFile)];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    _a++;
                    return [3 /*break*/, 2];
                case 5: return [4 /*yield*/, onFilesUpload(validFiles)];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 7:
                    error_1 = _c.sent();
                    // Mark all uploading files as error
                    setUploadQueue(function (prev) { return prev.map(function (f) {
                        return f.status === 'uploading'
                            ? __assign(__assign({}, f), { status: 'error', error: 'Upload failed' }) : f;
                    }); });
                    return [3 /*break*/, 9];
                case 8:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [disabled, isUploading, maxFiles, validateFile, onFilesUpload]);
    var handleDragEnter = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounterRef.current++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragOver(true);
        }
    }, []);
    var handleDragLeave = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounterRef.current--;
        if (dragCounterRef.current <= 0) {
            setIsDragOver(false);
        }
    }, []);
    var handleDragOver = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    var handleDrop = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        dragCounterRef.current = 0;
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files);
        }
    }, [handleFiles]);
    var handleInputChange = useCallback(function (e) {
        if (e.target.files && e.target.files.length > 0) {
            handleFiles(e.target.files);
        }
    }, [handleFiles]);
    var removeFromQueue = useCallback(function (id) {
        setUploadQueue(function (prev) { return prev.filter(function (f) { return f.id !== id; }); });
    }, []);
    var clearQueue = useCallback(function () {
        setUploadQueue([]);
    }, []);
    return (_jsxs("div", __assign({ className: cn("space-y-4", className) }, { children: [_jsxs("div", __assign({ onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop, className: cn("relative border-2 border-dashed rounded-lg p-8 text-center transition-all duration-200", isDragOver
                    ? "border-primary bg-primary/5 scale-102"
                    : "border-border hover:border-primary/50 hover:bg-muted/30", disabled && "opacity-50 cursor-not-allowed") }, { children: [_jsx("input", { ref: fileInputRef, type: "file", multiple: true, accept: acceptedTypes.join(','), onChange: handleInputChange, className: "hidden", disabled: disabled }), isDragOver ? (_jsxs("div", __assign({ className: "space-y-4" }, { children: [_jsx(CloudUpload, { className: "w-12 h-12 mx-auto text-primary animate-bounce" }), _jsxs("div", { children: [_jsx("p", __assign({ className: "text-lg font-medium text-primary" }, { children: "Drop files here" })), _jsx("p", __assign({ className: "text-sm text-muted-foreground" }, { children: "Release to upload" }))] })] }))) : (_jsxs("div", __assign({ className: "space-y-4" }, { children: [_jsx(Upload, { className: "w-12 h-12 mx-auto text-muted-foreground" }), _jsxs("div", { children: [_jsx("p", __assign({ className: "text-lg font-medium text-foreground mb-1" }, { children: "Drag & drop files here" })), _jsx("p", __assign({ className: "text-sm text-muted-foreground mb-4" }, { children: "or click to browse files" })), _jsxs(Button, __assign({ onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: disabled || isUploading, variant: "outline", className: "mx-auto" }, { children: [_jsx(Upload, { className: "w-4 h-4 mr-2" }), "Choose Files"] }))] }), _jsxs("div", __assign({ className: "text-xs text-muted-foreground space-y-1" }, { children: [_jsxs("p", { children: ["Supported formats: ", acceptedTypes.join(', ')] }), _jsxs("p", { children: ["Maximum file size: ", maxFileSize, "MB \u2022 Maximum files: ", maxFiles] })] }))] })))] })), showPreview && uploadQueue.length > 0 && (_jsxs("div", __assign({ className: "space-y-3" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between" }, { children: [_jsx("h4", __assign({ className: "font-medium text-foreground" }, { children: "Upload Queue" })), _jsx(Button, __assign({ variant: "ghost", size: "sm", onClick: clearQueue, className: "text-muted-foreground hover:text-foreground" }, { children: "Clear all" }))] })), _jsx("div", __assign({ className: "space-y-2 max-h-64 overflow-y-auto" }, { children: uploadQueue.map(function (uploadFile) {
                            var FileIcon = getFileIcon(uploadFile.file.type);
                            return (_jsxs("div", __assign({ className: "flex items-center space-x-3 p-3 border border-border rounded-lg bg-card" }, { children: [_jsx(FileIcon, { className: "w-8 h-8 text-muted-foreground flex-shrink-0" }), _jsxs("div", __assign({ className: "flex-1 min-w-0" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between mb-1" }, { children: [_jsx("p", __assign({ className: "text-sm font-medium text-foreground truncate" }, { children: uploadFile.file.name })), _jsx(Button, __assign({ variant: "ghost", size: "sm", onClick: function () { return removeFromQueue(uploadFile.id); }, className: "h-6 w-6 p-0 text-muted-foreground hover:text-foreground flex-shrink-0" }, { children: _jsx(X, { className: "w-3 h-3" }) }))] })), _jsxs("div", __assign({ className: "flex items-center justify-between text-xs text-muted-foreground mb-2" }, { children: [_jsx("span", { children: formatFileSize(uploadFile.file.size) }), _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [uploadFile.status === 'success' && (_jsxs("div", __assign({ className: "flex items-center space-x-1 text-success" }, { children: [_jsx(Check, { className: "w-3 h-3" }), _jsx("span", { children: "Complete" })] }))), uploadFile.status === 'error' && (_jsxs("div", __assign({ className: "flex items-center space-x-1 text-error" }, { children: [_jsx(AlertCircle, { className: "w-3 h-3" }), _jsx("span", { children: "Error" })] }))), uploadFile.status === 'uploading' && (_jsxs("span", { children: [uploadFile.progress, "%"] }))] }))] })), uploadFile.status === 'uploading' && (_jsx(Progress, { value: uploadFile.progress, className: "h-1" })), uploadFile.error && (_jsx("p", __assign({ className: "text-xs text-error mt-1" }, { children: uploadFile.error })))] }))] }), uploadFile.id));
                        }) }))] })))] })));
};
